<template>
	<div>
		<el-input 
			v-model="searchInput" 
			placeholder="搜索成员" 
			size="small" 
			suffix-icon="el-icon-search"
			style="padding:5px"
			@input="inputchange" />
		<div v-loading="loading" class="search-list">
			<el-tabs 
				tab-position="top" 
				type="border-card"
				style="height: 300px;overflow: auto;"
				v-model="activeName"
				@tab-click="handleClick">
				<el-tab-pane 
					v-for="(item,index) in list" 
					v-if="item.show"
					:key="item.structure_id + index"
					:label="item.structure_name"
					:name="`${item.structure_id}`">
					<el-checkbox-group 
						v-model="selectItems" 
						@change="changeCheckout">
						<el-checkbox 
							style="margin-right:20px;margin-top: 10px;"
							v-for="(value,key) in item.items"
							v-if="value.show"
							:key="item.structure_name+key"
							:label="value"
							:disabled="value.disabled">
							{{value.username}}
						</el-checkbox>
					</el-checkbox-group>
				</el-tab-pane>
			</el-tabs>
		</div>
	</div>
</template>
<script type="text/javascript">
	import { usersListByDep } from '@/api/common'
	import { mapGetters } from 'vuex'
	import Lockr from 'lockr'

	export default {
		name: 'XhUser', // 新建 user
		components: {},
		props: {
			value: {
				type: String,
				default: ''
			},
			/** 多选框 只能选一个 */
			radio: {
				type: Boolean,
				default: false
			},
			field: {
				type: String,
				default: ''
			},
			/** 已选信息 */
			selectedData: {
				type: Array,
				default: () => {
					return []
				}
			},
			infoRequest: Function
		},
		data() {
			return {
				list: [],//列表
				selectItems: [], // 选择项
				loading: false, // 加载动画
				searchInput: '',
				activeName:'0'
			}
		},
		computed: {
			...mapGetters(['userInfo'])
		},
		watch: {
			selectedData: function(value) {
				this.checkItems(value)
			},
			
		},
		mounted() {
			this.getUserList()
		},
		methods: {
			// 获取员工列表
			getUserList() {
				this.loading = true
				usersListByDep()
					.then(res => {
						var self = this
						this.list = res.data.map(function(items, key, array) {
							items.show = true
							items.items.map(function(item, k, arr) {
								if (self.selectedData.length > 0) {
									arr[k] = {
										username:item.username,
										id:item.id,
										disabled:self.radio,
										show: true
									}
									for (let index = 0; index < self.selectedData.length; index++) {
										const element = self.selectedData[index]
										if (element.id == item.id) {
											arr[k] = {
												username:item.username,
												id:item.id,
												disabled:false,
												show: true
											}
										}
									}
								}else{
									// 初始化
									arr[k] = {
										username:item.username,
										id:item.id,
										disabled:false,
										show: true
									}
								}
							})
							return items
						})
						this.activeName = this.userInfo.structure_id.toString()
						if(this.selectedData && this.selectedData.length > 0){
							this.checkItems(this.selectedData)
							this.activeName = this.selectedData[0].structure_id ? 
												this.selectedData[0].structure_id.toString() : 
												this.userInfo.structure_id.toString()
						}
						
						this.loading = false
					})
					.catch(() => {
						this.loading = false
					})
			},

			// 搜索
			inputchange(value) {
				// 使用filter方法筛选出包含特定label的对象  
				let arr = this.list
			  
				// 遍历筛选出来的对象，根据条件更新items的show属性，并更新对象本身的show属性  
				const updated = arr.map(item => {
					item.items = item.items.map(i => {
						if (i.username.includes(value)) {
							i.show = true 
						} else {  
							i.show = false
						}  
						return i 
					})
					item.show = item.items.some(i => i.username.includes(value))  
					return item 
				})
				
				let obj = updated.find(item=>item.show===true)
				if(obj){
					this.activeName = obj.structure_id.toString()
				}
				
				this.list = updated
			},

			changeCheckout(arr) {
				if (this.radio) {
					if (arr.length) {
						var element = arr[0]
						this.list = this.list.map(function(items, key, array) {
							items.items.map(function(item, k, arr) {
								if (element.id == item.id) {
									item.disabled = false
								} else {
									item.disabled = true
								}
							})
							return items
						})
					} else {
						this.list = this.list.map(function(items, index, array) {
							items.items.map(function(item, k, arr) {
								item.disabled = false
							})
							
							return items
						})
					}
				}
				
				this.$emit('changeCheckout', {
					data: this.selectItems
				})
			},
			
			/** 标记勾选 */
			checkItems(items) {
				this.selectItems = []
				if (items.length > 0) {
					for (let listIndex = 0; listIndex < this.list.length; listIndex++) {
						for (let listItemsIndex = 0; listItemsIndex < this.list[listIndex]["items"].length; listItemsIndex++) {
							const item = this.list[listIndex]["items"][listItemsIndex]
							let disabled = true
							for (let key = 0; key < items.length; key++) {
								const element = items[key]
								if (element.id == item.id) {
									disabled = false
									this.selectItems.push(item)
								}
							}
							if (this.radio) {
								item.disabled = disabled
							}
						}
					}
				}
			},
			
			/** 取消勾选 */
			cancelCheckItem(item) {
				var removeIndex = -1
				for (let index = 0; index < this.selectItems.length; index++) {
					const element = this.selectItems[index]
					if (element.id == item.id) {
						removeIndex = index
					}
				}
				this.selectItems.splice(removeIndex, 1)
				if (this.radio && this.selectItems.length == 0) {
					this.list = this.list.map(function(items, index, array) {
						items.items.map(function(item, k, arr) {
							item.disabled = false
						})
						
						return items
					})
				}
			},
			
			handleClick(tab, event) {
				this.activeName = tab.name
			},
			
			/** 取消所有勾选 */
			cancelAllCheckItem() {
				this.list = this.list.map(function(items, index, array) {
					items.items.map(function(item, k, arr) {
						item.disabled = false
					})
					
					return items
				})
			},
			
		}
	}
</script>
<style lang="scss" scoped>
	/* 选择员工 */
	.search-img {
		width: 24px;
		height: 24px;
		border-radius: 12px;
		vertical-align: middle;
		margin-right: 8px;
	}

	.search-list {
		padding: 5px;
		
	}

	.colleagues-list {
		padding: 5px;
		display: block;
		margin-left: 0;
	}

	/deep/ .el-tabs__item {
		font-size: 13px !important;
	}
	
	/deep/ .el-tabs__nav{
	    display: flex !important;
	    flex-wrap: wrap !important;
	}
	/deep/ .el-tabs__content {
	    height: 210px;
	    overflow: auto;
	}
	/deep/ .el-checkbox{
		min-width: 80px
	}
</style>